import { OrderType } from "../my-enum";

export function getOrderTypeKey(orderType: OrderType) {
  let keyStr: string = '';
  switch (orderType) {
    case 'in':
      keyStr = '接機';
      break;
    case 'out':
      keyStr = '送機';
      break;
    case 'point_to_point':
      keyStr = '接送';
      break;
    default:
      keyStr = 'N/A';
  }

  return keyStr;
}

export function getOrderBrandName(order: { brandId?: number | null; brandName?: string | null }): string {
  return order.brandName?.trim() || (order.brandId != null ? `品牌 #${order.brandId}` : '—');
}
